import React, { createContext, useContext, useMemo } from 'react'
import useMedia from 'use-media'

type MediaProps = {
  children: React.ReactNode
}

export const MediaQueryContext = createContext({
  mobileView: false
})

const mediaQueries = { mobile: '(max-width: 767px)' }

const MediaQueryProvider = ({ children }: MediaProps) => {
  const mobileView = useMedia(mediaQueries.mobile)
  const value = useMemo(() => ({ mobileView }), [mobileView])

  return <MediaQueryContext.Provider value={value}>{children}</MediaQueryContext.Provider>
}

export const useMediaQueryContext = () => useContext(MediaQueryContext)

export default MediaQueryProvider
